import React, { Suspense} from 'react'
import { AppContext } from './context/AppContext'
import { useThree, useFrame } from '@react-three/fiber'
import { Plane } from '@react-three/drei';
import { OrbitControls } from '@react-three/drei'
import { Environment, Sky } from '@react-three/drei'
import PlatformObject from './components/PlatformObject.jsx'
import { VideoMaterial, FallbackMaterial } from './components/VideoComponents.jsx';

export default function Experience() {

    const { isFullscreen, isMobile } = React.useContext(AppContext)
    const { camera, gl } = useThree()

    return (
        <>
            <OrbitControls
                camera={camera}
                enableDamping
                dampingFactor={0.1}
                enableZoom={isMobile}
                // minDistance={-80}
                maxDistance={82}
                rotateSpeed={isMobile? '0.6' : '0.1'}
                enabled={isFullscreen}
                enablePan={isMobile} 
                minPolarAngle={0} // Limit to 45 degrees from the bottom
                maxPolarAngle={isMobile ? Math.PI / 1.7 : Math.PI} // Limit to 90 degrees from the top
                />
            <Environment preset="sunset" />
            <ambientLight
                intensity={1.4} /> 

            <Sky distance={450000} turbidity={10} azimuth={180} />
            <PlatformObject />
            <Plane args={[2.05, 1.265]}
                position={[-15.01, -21.37, 39.89]}
                rotation={[0.05,-0.52,0.02]}>
                    <Suspense fallback={<FallbackMaterial />}>
                        <VideoMaterial />
                    </Suspense>
            </Plane>
        </>
    )
}